import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="app center pad">
      <h1>Page not found</h1>
      <Link className="btn secondary" to="/" style={{ display: 'inline-block', marginTop: 16 }}>
        Back to start
      </Link>
    </div>
  );
}
